import React, {Component} from 'react';
import CButton from '@/components/CButton'
import{dpeprovincelistindex} from "../../utils/dpedatadef";
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import { withRouter} from 'react-router-dom'
import {Menu, Dropdown, Icon, message, Modal} from 'antd';
import CSelect from "../../components/CForm/CSelect";
import {museumnamematch} from "../../servers/goodsManageApi";
import store from "../../redux";
import { setStorage,getStorage} from "@/utils";
import './index.scss'
import {
  collapsedToggle,
  setWindowInfo,
  setUserInfo,
  setCurrentTheme,
  setUserList,
  setMenu,
  setLibraryArr, setLibrary,setLbname,refreshMenu,setYear
} from "../../redux/common/action";
import config from '@/config'
import { loginout } from "@/servers/commonApi";
import {clearboth} from "../../utils/clear";

class Header extends Component{

  constructor(props) {
    super(props);
    this.menuClick = this.menuClick.bind(this);
    this.changProvinceHandler = this.changProvinceHandler.bind(this)
    this.chooseLibbrary = this.chooseLibbrary.bind(this)
  }

  state = {
    time: null,
    provinve:[],
    provinceid:'-1',
    level:[
      {name:'全部',id:-1},
      {name:'一级',id:1410},
      {name:'二级',id:1411},
      {name:'三级',id:1412},
    ],
    levelid:-1,
    library:[],
    libraryid:'',
    yearrange:[],
    year:''
  };

  menuClick(data){
    const userInfo = getStorage('userList')
    const result =  this.changeitem(userInfo.menulist)
    result.splice(1,1)
    setStorage('menu', result);
    this.props.setMenu(result);
    this.props.history.push({
      pathname: '/personinfo',
    });
  }

  changeitem(data){
    data.forEach(item=>{
      item.showids = item.id
      if (item.children){
        this.changeitem(item.children)
      }
    })
    return data
  }

  componentWillMount(){
    const data = dpeprovincelistindex
    const userInfo = getStorage('userList')
    const year = getStorage('year')

    this.setState({
      type:userInfo.clerklevel,
      provinve:data
    })
    if (userInfo.museumname) {
      this.setState({
        museum:userInfo.museumname,
        year:year
      })
    } else {
      const state = store.getState()
      if (state.libraryname){
        const params = {
          museumname:state.libraryname,
        }
        museumnamematch(params).then(res=>{
          if (res.records.length > 0) {
            const result = res.records
            this.props.setLibraryArr(result)
            this.setState({
              library:result,
              libraryid: state.libraryid
            })
          } else {
            this.props.setLibraryArr([])
            this.setState({
              library:[],
              libraryid: ''
            })
          }
        })
      }
    }
    let currentState = store.getState();
    const yearrange = JSON.parse(localStorage.getItem('userList')).yearrange
    if (yearrange){
      const arr = []
      yearrange.forEach(item=>{
        let obj = {}
        obj.name = item
        obj.id = item
        obj.value = item
        arr.push(obj)
      })
      this.setState({
        yearrange:arr,
      })
    }
    this.setState({
      year:currentState.year
    })
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      // if (previousState.libraryid !== currentState.libraryid) {
      //   const params = {
      //     museumname:currentState.libraryname,
      //   }
      //   museumnamematch(params).then(res=>{
      //     if (res.records.length > 0) {
      //       const result = res.records
      //       this.props.setLibraryArr(result)
      //       this.setState({
      //         library:result,
      //         libraryid: currentState.libraryid
      //       })
      //     } else {
      //       this.props.setLibraryArr([])
      //       this.setState({
      //         library:[],
      //         libraryid: ''
      //       })
      //     }
      //   })
      // }
      if (previousState.year !== currentState.year) {
        this.setState({
          year:currentState.year
        })
      }
    })

  }

  logout(){
    Modal.confirm({
      content: '确认退出系统？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        loginout().then(res => {
          if (res.statecode === 0) {
            // 退出
            clearboth()
            this.props.history.push({
              pathname: '/'
            })
          } else {
            message.error(res.statemessage);
          }
        })
      }
    })
  }

  changProvinceHandler(value,type){
    this.setState({
      [type]:value
    },()=>{
      const params = {
        provinceid:this.state.provinceid == -1 ? '': this.state.provinceid,
        levelid:this.state.levelid == -1 ? '' : this.state.levelid
      }
      museumnamematch(params).then(res=>{
        if (res.records.length > 0) {
          const result = res.records
          this.props.setLibraryArr(result)
          this.setState({
            library:result,
          })
        } else {
          this.props.setLibraryArr([])
          this.setState({
            library:[],
          })
        }
      })
    })
  }

  chooseLibbrary(value){
    this.setState({
      libraryid:value
    })
    let str = ''
    // const arr = []
    for (let i =0;i<this.state.library.length;i++){
      if (this.state.library[i].id === value){
        str = this.state.library[i].name
        // arr.push(this.state.library[i])
        break
      }
    }
    this.props.setLbname(str)
    this.props.setLibrary(value)
    localStorage.setItem('library',value)
    const location = window.location.href
    if (location.includes('home')){
      let userInfo =JSON.parse(localStorage.getItem('userList'))
      if (userInfo.clerklevel == 3 || userInfo.clerklevel == 4 || userInfo.clerklevel == 16) {
        localStorage.setItem('chooseid','131110')
        this.props.history.push({
          pathname: '/informationDeclaration/museumbaseinfo/baseCentral',
        });
      } else if (userInfo.clerklevel == 10 || userInfo.clerklevel == 11) {
        localStorage.setItem('chooseid','131110')
        this.props.history.push({
          pathname: '/informationDeclaration/museumbaseinfo/baseScore',
        });
      } else {
        localStorage.setItem('chooseid','131110')
        this.props.history.push({
          pathname: '/informationDeclaration/museumbaseinfo/baseProvince',
        });
      }
    }
  }
  selectYear(value){
    this.setState({
      year:value
    })
    localStorage.setItem('year',value)
    this.props.setYear(value)
  }


  componentWillUnmount(){
    clearTimeout(this.state.time);
  }


  render(){
    const userList = this.props.userList;
    let name = ''
    if (userList!==null && JSON.stringify(userList) !== '{}'){
      name = userList.clerkrealname;
    }

    const menu = (
        <Menu>
          <Menu.Item>
            <CButton type='text' block onClick={() => this.menuClick()}>个人信息</CButton>
          </Menu.Item>
        </Menu>);
    return (
        <header className='flex text-color-white header'>
          <div className='logo'>
            {/*<img src={logo} alt=""/>*/}
            {config.name}
          </div>
          <div className='flex info'>
            <div className='flex collapsed'>
              <Icon type="menu-fold"/>
              <div className='breadcrumb'>
                {this.state.museum !== '' && this.state.museum !== null && this.state.museum !== undefined ? this.state.museum+'/'+this.state.year :
                    <div className='select-libbrary'>
                      {this.state.type == 6 || this.state.type == 7 ? '' :
                          <CSelect value={this.state.provinceid} options={this.state.provinve}
                                   placeholder='请选择所处省份'
                                   onChange={(value) => this.changProvinceHandler(value, 'provinceid')}/>}
                      <CSelect value={this.state.levelid} options={this.state.level} placeholder='请选择申报等级'
                               onChange={(value) => this.changProvinceHandler(value, 'levelid')}/>
                      <div className='long'>
                        <CSelect value={this.state.libraryid} options={this.state.library} placeholder='请选择博物馆'
                                 onChange={(value) => this.chooseLibbrary(value, 'libraryid')}/>
                      </div>
                        <CSelect value={this.state.year} options={this.state.yearrange} placeholder='请选择年份'
                                 onChange={(value) => this.selectYear(value, 'year')}/>
                    </div>
                }
              </div>
            </div>
            <div className='flex info-right'>
              <div className='user-info' ref='userInfo'>
                <Dropdown overlay={menu} getPopupContainer={() => this.refs.userInfo}>
                <span>
                  {/*<img className='user-avatar' src={url} alt=""/>*/}
                  <span className='user-name'>
                    {name}</span>
                  <Icon type="down"/>
                </span>
                </Dropdown>
                <span className='logoutindex' onClick={() => {
                  this.logout()
                }} style={{marginLeft: '30px', cursor: 'pointer'}}>
                退出
              </span>
              </div>
            </div>
          </div>
          {/*<div className='flex info'>*/}
          {/*  <div className='flex collapsed' onClick={this.collapsedChange}>*/}
          {/*    <Icon type="menu-fold"/>*/}
          {/*    <div className='breadcrumb'>*/}
          {/*      <CBreadcrumb data={this.props.breadcrumbData}/>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*  <div className='flex info-right'>*/}
          {/*    <div className='user-info' ref='userInfo'>*/}
          {/*      <Dropdown overlay={menu} getPopupContainer={() => this.refs.userInfo}>*/}
          {/*      <span>*/}
          {/*        /!*<img className='user-avatar' src={url} alt=""/>*!/*/}
          {/*        <span className='user-name'>*/}
          {/*          {name}</span>*/}
          {/*        <Icon type="down"/>*/}
          {/*      </span>*/}
          {/*      </Dropdown>*/}
          {/*      <span className='logoutindex' onClick={() => {*/}
          {/*        this.logout()*/}
          {/*      }} style={{marginLeft: '30px', cursor: 'pointer'}}>*/}
          {/*      退出*/}
          {/*    </span>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </header>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    breadcrumbData: state.breadcrumbData,
    collapsed: state.collapsed,  // 侧边栏是否展开
    windowInfo: state.windowInfo,
    userInfo: state.userInfo,
    userList: state.userList,
    libraryid: state.libraryid,
    setLbname:state.setLbname
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
    setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
    setUserInfo: bindActionCreators(setUserInfo, dispatch),
    setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
    setUserList: bindActionCreators(setUserList, dispatch),
    setMenu: bindActionCreators(setMenu, dispatch),
    setLibraryArr: bindActionCreators(setLibraryArr, dispatch),
    setLibrary:bindActionCreators(setLibrary,dispatch),
    setLbname:bindActionCreators(setLbname,dispatch),
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
    setYear:bindActionCreators(setYear,dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Header);
